<template>
  <div id="gallery">

    <transition name="fade">
      <div v-if="$route.query.gallery" class="main-container">

        <gallery :images="images" :index="imageIndex" @close="closed"></gallery>

      </div>
    </transition>

  </div>
</template>

<script>
  
  import VueGallery from 'vue-gallery';

  export default {
    components: {
      'gallery': VueGallery
    },
    data () {
      return {
        images: [],
        imageIndex: null
      }
    },
    methods: {
      
      show (images, index) {
        this.imageIndex = null;
        var iArray = [];
        
        images.forEach(i => {
          iArray.push(i.uri);
        });
        
        this.images = iArray;
                
        this.routeAddQuery('gallery');
        
        this.$nextTick(() => {
          this.imageIndex = index || 0;
        });

      },

      closed () {
        this.routeRemoveQuery('gallery');
      }

    },

    created () {
      window.Gallery = this;
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #gallery {
    
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;

    .main-container {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      pointer-events: auto;

      .slide {
        position: relative;
        width: 100%;
        height: 100%;
      }
    }

    .fab {
      position: absolute;
      right: 0;
      top: 0;
      background: $primary;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/Gallery.vue